module.exports = __webpack_public_path__ + "img/0561d3b.svg";